import Slider from "react-infinite-logo-slider";
import { clients } from "../utils/clients";

interface ClientLogosProps {
  direction?: "left" | "right";
}

export function ClientLogos({ direction = "left" }: ClientLogosProps) {
  return (
    <div className="relative flex h-[167px] items-center justify-center overflow-hidden py-8">
      <Slider
        width="180px"
        duration={40}
        toRight={direction === "right"}
        pauseOnHover={true}
        blurBorders={false}
        blurBorderColor={"#fff"}
      >
        {clients.map((client, index) => (
          <Slider.Slide key={`${client.name}-${index}`}>
            <img
              src={client.logo}
              alt={client.name}
              width={120}
              height={60}
              loading="lazy"
              className="h-[60px] w-[120px] object-contain opacity-60 grayscale filter transition-opacity duration-500 hover:opacity-100 hover:grayscale-0"
            />
          </Slider.Slide>
        ))}
      </Slider>
    </div>
  );
}
